export default __webpack_public_path__ + "static/media/filter.6016efd6.svg";